import React, { useEffect, Fragment } from 'react';
import {utilService, getQueryString} from '../../Utils/Utils/index'
import {apiService} from '../../Fetch/idcardApiService'
import LightMobileCall from "@kugou/light-mobilecall";
import e from '../../Utils/Event'
export default function FaceRecognition(props) {
  let { jumpUrl, openRecognite, name, idNum, showTips, reqId, faceAuthBack, setShowTipsDialog, showIDCardEnter } = props;
  let hasSysAccess = false;
  
  let idcard = {
    status: 0, // 0: 未认证; 1: 认证中; 2: 认证成功; 3: 认证失败;  -1: 系统繁忙;  -2: 填写身份证号码; -3: 没有摄像头权限
    verifytype: 0,
    idcard: {
      name: "",
      num: ""
    },
    authErrMsg: "认证失败，请重试",
    cmd: {
      closeFrame: 158,
      savePreReturnPage: 710,
      haveSysAccess: 821,
      verifyResCallback: 1069
    },
    ksCallbackData: {
      count: 0
    },
    // 获取用户实名认证状态
    getIDCardAuth: function() {
      let me = this;
      let appid = window.$userInfo.appid;
      let clientver = window.$userInfo.clientver;
      let mid = window.$userInfo.mid_v2 || window.$userInfo.mid;
      let uuid = window.$userInfo.uuid ? window.$userInfo.uuid : mid;
      let dfid = window.$userInfo.dfid;
      let plat = window.$userInfo.plat;
      let userid = window.$userInfo.userid;
      let token = window.$userInfo.token;

      apiService.getIDCardAuth(appid, clientver, mid, uuid, dfid, plat, userid, token).then(function(response) {
        let res = response.data;
        
        if (res.status == 1) {
          let realAuth = res.data.real_auth; // 这里拿的是 real_auth 人脸核身认证的结果
          realAuth = 0;
          if (realAuth == 0) {
            // 0-未认证
            me.status = 0;
            // 开始认证
            me.startAddIDCardInfo();
          } else if (realAuth == 1) {
            // 1-审核中
            me.status = 1;
          } else if (realAuth == 2) {
            // 2-已认证
            me.status = 2;
          } else if (realAuth == 3) {
            // 3-审核不通过
            // 一进入页面，判断认证失败，就直接拉起身份证填写页面，不展示认证失败了。
            me.status = 0;
            // 开始认证
            me.startAddIDCardInfo();
          }
        } else {
          // 接口错误，状态 -1: 系统繁忙
          me.status = -1;

          let errmsg = "系统异常，请稍后再试";
          window.$Msg(res.data ? res.data : errmsg);
        }
      }).catch(function(err) {
        // 状态 -1: 系统繁忙
        me.status = -1;
      });
    },

    // 进入填写身份证页面
    startAddIDCardInfo: function() {
      let me = this;
      me.status = -2;
    },

    // 拉起腾讯云人脸核身页面
    openIDCardIdentification: function() {
      let me = this;
      me.loadingScanFace = true;
      e.emit('loading', true)
      // 已经有摄像头权限
      if (hasSysAccess) {
        //奇怪的报错兼容，err appid(srcappid) or clientver or mid or dfid
        if(!window.$userInfo.clientver || window.$userInfo.token == 'default' || !window.$userInfo.mid || !window.$userInfo.appid){
          window.$getUserInfo(()=>{
            me.getRealAuth();
          },true)
        }else{
          me.getRealAuth();
        }
        return null;
      }

      // 获取认证数据，拉起扫脸
      if ((LightMobileCall.isKugouAndroid || LightMobileCall.isAndroid) && window.$userInfo.clientver >= 10007) {
        // android 有兼容性，10007 版本以上先判断权限，再开启
        LightMobileCall.mobileCall(me.cmd.haveSysAccess, {});
        if(!me.haveAccess){
          me.haveAccess = true
          LightMobileCall.KgWebMobileCall("KgWebMobileCall.haveSysAccess", (res)=> {
            try {
              res = JSON.parse(res);
            } catch (error) {
              
            }
            if (res && res.status == 1) {
              if(!hasSysAccess){//避免获取权限后重复执行
                hasSysAccess = true;
                // 有摄像头权限
                idcard.openIDCardIdentification();
              }
            } else {
              // 没有摄像头权限
              idcard.loadingScanFace = false;
              e.emit('loading', false)
              idcard.status = -3;
              showTips("您当前没有开启访问摄像头权限，所以无法进行认证。请在手机“设置”开启摄像头权限后，再来认证哦~",[{ text: '已开启，继续认证', fn: () => {setShowTipsDialog(false);idcard.reStartAuth()} }])
            }
          });
        }
        return null;
      }
      //奇怪的报错兼容，err appid(srcappid) or clientver or mid or dfid
      if(!window.$userInfo.clientver || window.$userInfo.token == 'default' || !window.$userInfo.mid || !window.$userInfo.appid){
        window.$getUserInfo(()=>{
          me.getRealAuth();
        },true)
      }else{
        me.getRealAuth();
      }
    },

    // 获取腾讯云认证需要的token等参数
    getRealAuth: function() {
      let me = this;
      
      if (LightMobileCall.isInClient() && LightMobileCall.isIOS) {
          window.$userInfo.plat = 2;
      } else if (LightMobileCall.isInClient() && !LightMobileCall.isIOS) {
          window.$userInfo.plat = 1;
      }
      const verifytype = me.verifytype ? me.verifytype : 0; // 0: 身份证实名认证;  1: 人脸核身
      let source = 0;
      let mid = window.$userInfo.mid_v2 || window.$userInfo.mid;
      const baseInfo = {
        appid: window.$userInfo.appid,
        clientver: window.$userInfo.clientver,
        mid: window.$userInfo.mid_v2 || window.$userInfo.mid,
        uuid: window.$userInfo.uuid ? window.$userInfo.uuid : mid,
        dfid: window.$userInfo.dfid ? window.$userInfo.dfid : "-",
				plat: window.$userInfo.plat,
				userid: window.$userInfo.userid,
				token: window.$userInfo.token,
			}
      
      // 身份证信息
      name = utilService.trim(name);
      let idno = utilService.trim(idNum);
      let biz = "musician_enter";
      let serviceType = null; // 选择第三方服务商，0：腾讯云，1：阿里云，默认0，2旷视 如果不传此参数，则由后端自动适配分配供应商出去
      if(getQueryString("debug") && getQueryString("serviceType")){
        serviceType = parseInt(getQueryString("serviceType"))
      }
      if(process.env.NODE_ENV == 'development'){
        console.log(`姓名：${name}, 身份证：${idNum}`);
      }

      apiService.getRealAuth(baseInfo, verifytype, source, name, idno, biz, serviceType, function(response) {
        let res = response.data;
        console.log(res, 'apiService.getRealAuth');
        if (res && res.status == 1) {
          if (res && res.data && res.data.serviceType == 0) {
						// 腾讯云
						me.initDataToWeBankVerify(res);

						return null;
					}

					if (res && res.data && res.data.serviceType == 2) {
						// 旷视
						me.initDataToKSVerify(res);
						return null;
					}
          
        } else {
          me.loadingScanFace = false;
          e.emit('loading', false)
          //用户已经认证过了，这次是进行校验是不是认证本人操作，扫脸登录
          if( res.error_code == 34232 ){
            me.verifytype = 1;
            //奇怪的报错兼容，err appid(srcappid) or clientver or mid or dfid
            if(!window.$userInfo.clientver || window.$userInfo.token == 'default' || !window.$userInfo.mid || !window.$userInfo.appid){
              window.$getUserInfo(()=>{
                me.getRealAuth();
              },true)
            }else{
              me.getRealAuth();
            }
          } else if( res.error_code ==  34329 ){
            window.$Msg('实名信息对比错误')
            showIDCardEnter()
          } else{
            let errmsg = "系统异常，请稍后再试";
            window.$Msg(res.data ? res.data : errmsg)
          }
        }
      }, function(err) {
        me.loadingScanFace = false;
        e.emit('loading', false)
        window.$Msg('网络异常，请稍后再试')
      });
    },

    // 腾讯云H5扫脸准备
		initDataToWeBankVerify: function (res) {
			const me = this;

			let h5faceId = res.data.h5faceId;
			let nonce = res.data.nonce;
			let orderNo = res.data.orderNo;
			let sign = res.data.sign;
			let ticket = res.data.ticket;
			let userId = res.data.userId;
			let version = res.data.version;
			let webankAppId = res.data.webankAppId;

			
			// 认证成功回调页面地址
			let webackBackUrl = "";
			webackBackUrl = jumpUrl;

			me.gotoWeBankPage(webankAppId, version, nonce, orderNo, h5faceId, webackBackUrl, userId, sign);
		},

    // 拉起腾讯云扫脸
    gotoWeBankPage: function(webankAppId, version, nonce, orderNo, h5faceId, url, userId, sign) {
      const me = this;
      //console.log(url, 'jumpUrl');
      
      let txVerifyUrl = "https://ida.webank.com/api/web/login?" + 
				"webankAppId=" + webankAppId + 
				"&version=" + version +
				"&nonce=" + nonce +
				"&orderNo=" + orderNo +
				"&h5faceId=" + h5faceId +
				"&url=" + url +
				"&resultType=" + 1 +
				"&userId=" + userId +
				"&sign=" + sign + 
				"&from=browser" + 
				"&redirectType=" + 1;

      e.emit('loading', false);
      LightMobileCall.mobileCall(123, {url: txVerifyUrl});
    },

    // 腾讯云认证成功，跳转回来，处理
    weBankBackHandle: function() {
      let me = this;
      // url 参数获取
			let orderNo = utilService.getUrlParam("orderNo");
			let code = utilService.getUrlParam("code");
			let newSignature = utilService.getUrlParam("newSignature");

      const serviceType = 0 // 0: 腾讯云

			const verifyData = {
				orderNo: orderNo,
				code: code,
				newSignature: newSignature
			}
			
			// 	其他业务，调用接口扫脸结果
			me.requestApiVerifyIDCardInfo(serviceType, verifyData);
    },

    // 	拉起旷视数据准备
		initDataToKSVerify: function (res) {
			const me = this;

			const biz_token = res && res.data && res.data.biz_token;
			const biz_no = res && res.data && res.data.biz_no;
			const request_id = res && res.data && res.data.request_id;

			const serviceType = res && res.data && res.data.serviceType;

			if (biz_token && request_id) {
				me.ksVerifyFinishHandle(serviceType);

				LightMobileCall.mobileCall(1071, {
					biz_token: biz_token,
					biz_no: biz_no,
					request_id: request_id
				})
			} else {
        window.$Msg('获取实名认证参数失败，请重试！');
				return null;
			}
		},

		// 旷视认证结果处理
		ksVerifyFinishHandle: function(serviceType) {
			const me = this;

			// 清掉回调，避免多次监听到
			if (window.KgWebMobileCall && window.KgWebMobileCall.megviiFaceCallback) {
				window.KgWebMobileCall.megviiFaceCallback = null;
			}

			LightMobileCall.KgWebMobileCall("KgWebMobileCall.megviiFaceCallback", function(res) {
				try {
					res = JSON.parse(res);
				} catch (error) {}

				let meglive_data = "";
				const biz_token = res.biz_token;

				if (res && res.status == 1) {
					let dataobject = res.meglive_data;
					try {
						dataobject = JSON.parse(dataobject);
					} catch (error) {}

					if (dataobject.count && dataobject.count > 0) {
						// 新版的，分段返回
						me.ksCallbackData.count = dataobject.count;
						me.ksCallbackData[dataobject.split] = dataobject.value;

						let resNum = 0;
						for (let i = 0; i < dataobject.count + 1; i++) {
							if (me.ksCallbackData[i]) {
								resNum++;
							}
						}
							
						if (resNum == dataobject.count) {
							// 全部收集完成，拼装，发请求
							let allRes = "";

							for (let i = 0; i < me.ksCallbackData.count + 1; i++) {
								if (me.ksCallbackData[i]) {
									allRes = allRes + me.ksCallbackData[i];
								}
							}

							meglive_data = allRes;

							const verifyData = {
								meglive_data: meglive_data,
								biz_token: biz_token,
							};

							me.requestApiVerifyIDCardInfo(serviceType, verifyData);

						}
					}  else {
						// 旧版的，直接返回
						// 成功
						meglive_data = res.meglive_data;

						const verifyData = {
							meglive_data: meglive_data,
							biz_token: biz_token,
						};

						me.requestApiVerifyIDCardInfo(serviceType, verifyData);
					}

				} else {
					// 失败
					me.loadingScanFace = false;

					const errMsg = res.err_msg || "";
					const errCode = res.err_code || "";

					if (errCode == 30001) {
            window.$Msg('请在手机“设置”开启摄像头权限后，再来认证哦~');
						return null;
					}

					if (errCode == -1) {
						// 旷视插件加载失败
            window.$Msg('认证失败， 请稍后重试！');
						return null;
					}

					let errToast = "扫脸失败，请稍后再试";
					if (errMsg && errMsg != "" && errMsg != "") {
						errToast = errMsg;
					} else if (errCode) {
						errToast = errToast + ": " + errCode;
					}

          if (res.err_msg == "USER_CANCEL") {
            // 用户取消，不要 toast
            errToast = "请完成人脸认证";
            e.emit('loading', false);
            //return null;
          } else if (res.err_msg == "NETWORK_TIME_OUT") {
            errToast = "网络请求超时，请稍后再试";
          } else if (res.err_msg == "INVALID_BUNDLE_ID") {
            errToast = "信息验证失败，请重启app后重试";
          } else if (res.err_msg == "NETWORK_ERROR") {
            errToast = "连不上互联网，请连接上互联网后重试";
          } else if (res.err_msg == "LIVENESS_TIME_OUT") {
            errToast = "操作超时";
          } else if (res.err_msg == "GO_TO_BACKGROUND") {
            errToast = "应用退到后台，检测失败";
          } else if(res.err_msg == "NO_CAMERA_PERMISSION") {
            errToast = "没有打开相机的权限，请开启权限后重试";
          } else if (res.err_msg == "NO_WRITE_EXTERNAL_STORAGE_PERMISSION") {
            errToast = "无法读取写SD卡的权限，请开启权限后重试";
          }

          window.$Msg(errToast);
				}
			});
		},

    // 调用接口，验证扫脸结果
		requestApiVerifyIDCardInfo: function (serviceType, verifyData) {
			const me = this;

      if (LightMobileCall.isInClient() && LightMobileCall.isIOS) {
        window.$userInfo.plat = 2;
      } else if (LightMobileCall.isInClient() && !LightMobileCall.isIOS) {
        window.$userInfo.plat = 1;
      }
      let mid = window.$userInfo.mid_v2 || window.$userInfo.mid;
			const baseInfo = {
        appid: window.$userInfo.appid,
        clientver: window.$userInfo.clientver,
        mid: window.$userInfo.mid_v2 || window.$userInfo.mid,
        uuid: window.$userInfo.uuid ? window.$userInfo.uuid : mid,
        dfid: window.$userInfo.dfid ? window.$userInfo.dfid : "-",
        plat: window.$userInfo.plat,
        userid: window.$userInfo.userid,
        token: window.$userInfo.token,
			};

			let biz = "musician_enter";

			apiService.verifyIDCardInfo(baseInfo, serviceType, verifyData, biz, function(response) {
				let res = response.data;
        console.log(res, 'apiService.verifyIDCardInfo');
				if (res && res.status == 1) {
					// 请求成功
					if (res.data.result === true || res.data.result === "true") {
						// 认证成功
						me.status = 2;

						// 将认证信息写入 cookie 5分钟
						let res_verify_cookie = {status: 1};
						if (serviceType == 0) {
							// 腾讯云
							res_verify_cookie = Object.assign(res_verify_cookie, verifyData);
						}

						if (serviceType == 2) {
							// 旷视
							res_verify_cookie = Object.assign(res_verify_cookie, {orderNo: verifyData.biz_token});
						}
						
						const cookieValue = JSON.stringify(res_verify_cookie);

						utilService.Cookie.write("kg_faceid", cookieValue, 5*60*1000, "/", "kugou.com");
            localStorage.setItem("kg_faceid", cookieValue)
						LightMobileCall.mobileCall(me.cmd.verifyResCallback, {status: 1});
					} else {
						// 认证失败
						me.status = 3;
						me.authErrMsg = res.data.err_msg ? res.data.err_msg : me.authErrMsg;

						const errorMsg = me.authErrMsg ? encodeURIComponent(me.authErrMsg) : "";

						// 将认证信息写入 cookie
						let res_verify_cookie = {
							status: 0,
							errorCode: res.data.error_code,
							errorMsg: errorMsg
						};
						if (serviceType == 0) {
							// 腾讯云
							res_verify_cookie = Object.assign(res_verify_cookie, verifyData);
						}
						if (serviceType == 2) {
							// 旷视
							res_verify_cookie = Object.assign(res_verify_cookie, {orderNo: verifyData.biz_token});
						}

						const cookieValue = JSON.stringify(res_verify_cookie);

						utilService.Cookie.write("kg_faceid", cookieValue, 5*60*1000, "/", "kugou.com");
            localStorage.setItem("kg_faceid", cookieValue)

						// 命令号通知客户端验证结果，任务中心，还有一些独立app需要
						LightMobileCall.mobileCall(me.cmd.verifyResCallback, {
							status: 0, 
							verifyData: {
								errorCode: res.data.error_code + "",
								errorMsg: errorMsg
							}
						});
					}

				} else {
					// 认证失败
					me.status = 3;

					let errmsg = "系统异常，请稍后再试";
					me.authErrMsg = res.data ? res.data : errmsg;
          const errorMsg = me.authErrMsg ? encodeURIComponent(me.authErrMsg) : "";
					// 将认证信息写入 cookie
					let res_verify_cookie = {
						status: 0,
						errorCode: res.data.error_code,
						errorMsg: errorMsg
					};
					if (serviceType == 0) {
						// 腾讯云
						res_verify_cookie = Object.assign(res_verify_cookie, verifyData);
					}
					if (serviceType == 2) {
						// 旷视
						res_verify_cookie = Object.assign(res_verify_cookie, {orderNo: verifyData.biz_token});
					}

					const cookieValue = JSON.stringify(res_verify_cookie);
					utilService.Cookie.write("kg_faceid", cookieValue, 5*60*1000, "/", "kugou.com");
          localStorage.setItem("kg_faceid", cookieValue)

					LightMobileCall.mobileCall(me.cmd.verifyResCallback, {
						status: 0, 
						verifyData: {
							errorCode: "",
							errorMsg: me.authErrMsg ? encodeURIComponent(me.authErrMsg) : ""
						}
					});
				}
				me.loadingScanFace = false;
        e.emit('loading', false)
        if(serviceType == 0){// 腾讯云
          me.closePage();
        }else{
          e.emit('face_auth_back')
        }
			}, function(err) {
				// 出现异常，展示系统繁忙
				me.status = -1;
				me.loadingScanFace = false;
        e.emit('loading', false)
        // 将认证信息写入 cookie
        const cookieValue = JSON.stringify({
          status: 0,
          errorMsg: encodeURIComponent('系统繁忙，请稍后再试！')
        });
        utilService.Cookie.write("kg_faceid", cookieValue, 5*60*1000, "/", "kugou.com");
        localStorage.setItem("kg_faceid", cookieValue)
        if(serviceType == 0){// 腾讯云
          me.closePage();
        }else{
          e.emit('face_auth_back')
        }
			});
		},

    closePage(){
      let me = this;
      setTimeout(function() {
        if (LightMobileCall.isIOS) {
          LightMobileCall.mobileCall(me.cmd.closeFrame, {type: 6});
          return null;
        } else {
          LightMobileCall.mobileCall(me.cmd.closeFrame, {type: 2});
        }

      }, 200)
    },

    // 确定，完成认证
    finishFaceAuth: function() {
      let me = this;

      if (LightMobileCall.isIOS) {
        LightMobileCall.mobileCall(me.cmd.closeFrame, {type: 6});
        return null;
      } else {
        LightMobileCall.mobileCall(me.cmd.closeFrame, {type: 2});
      }

    },

    // 重新开始认证
    reStartAuth: function() {
      const me = this;

      if (me.verifytype == 1) {
        // 人脸核身
        me.openIDCardIdentification(name, idNum);
      } else {
        // 身份证认证
        me.startAddIDCardInfo();
      }
    }
  }
  
  function recognite(){
    idcard.openIDCardIdentification(name, idNum);
  }

  useEffect(() => {
    console.log(window.location.href, '链接地址');
  }, [])

  useEffect(() => {
    if(openRecognite){
      recognite();
      return;
    }
    if(faceAuthBack && !openRecognite){
      window.$getUserInfo(()=>{
        // 身份证认证 - 腾讯云认证成功，跳转回来的
        idcard.verifytype = 0;
        idcard.weBankBackHandle();
      })
    }
  }, [openRecognite, faceAuthBack])

  return (<Fragment></Fragment>)
} 